import type { Business } from '@/types/services/business';

/**
 * Canonical business id accessor.
 *
 * `Business` carries both a DTO `id` and an optional mongo `_id` depending on where the object
 * was hydrated. Callers that need "the id" should use this instead of reinventing the
 * `business?.id ?? business?._id` coalesce at every site.
 */
export function getBusinessId(business: Business | null | undefined): string | undefined {
  return business?.id ?? business?._id ?? undefined;
}
